// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewCategory_root__CXvF2","title":"ReviewCategory_title__B5ldJ"};